import React from 'react';
import { Control } from 'react-hook-form';
import { CreateEmailDto } from '../../../CreateEmailDto';
import { HeaderRow } from '../HeaderRow';
import { EmailTemplate } from '../../../../../../../entities/EmailTemplate';
import { UpdateStatePlugin } from '../../../../../../../components/RichTextEditor/plugins/UpdateStatePlugin';
import { InputRichTextComposer } from '../../../../../../../components/RichTextEditor/composers/InputRichTextComposer';
import { InputFormField } from '../../../../../../../components/InputFormField';
import { Email } from '../../../../../../../entities/Email';
import { RichTextEditor } from '../../../../../../../components/RichTextEditor';

interface PropTypes {
  replyToEmail?: Email;
  emailTemplate?: EmailTemplate;
  control: Control<CreateEmailDto, any>;
  setSubjectText: (text: string) => void;
}

function DisabledSubject(props: { subject: string }) {
  return (
    <InputFormField
      hideHeader={true}
      disabled
      classNames='fs-5 fw-normal'
      type='text'
      registerReturn={null}
      value={props.subject}
    />
  );
}

export function Subject(props: PropTypes) {
  return (
    <HeaderRow label='Subject'>
      {props.replyToEmail != null ? (
        <DisabledSubject subject={props.replyToEmail.subject} />
      ) : (
        <RichTextEditor<CreateEmailDto>
          formHookContext={{
            controllerName: 'subject',
            formControl: props.control,
            required: true,
          }}
          render={(field) => (
            <InputRichTextComposer
              defaultEditorState={props.emailTemplate?.subject}
              externalPlugins={[
                <UpdateStatePlugin
                  key={1}
                  editorState={props.emailTemplate?.subject}
                />,
              ]}
              placeholder='Insert subject'
              onChangeJson={(value: string) => field.onChange(value)}
              onChangeText={props.setSubjectText}
            />
          )}
        />
      )}
    </HeaderRow>
  );
}
